var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5e00c58462921cc6d995223115fbf5584a670f26"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["prom@nicholas-gregory"]={id:"5e00c58462921cc6d995223115fbf5584a670f26"};
      